import getVectorImage from '../../utils/getVectorImage'
import getThresholdValue from '../../utils/getThresholdValueAllergies'
import toTitleCase from './../../utils/toTitleCase'
import moment from 'moment'
import toFixed from '../../utils/toFixed'
function toolTipFormatter() {
  let imageName = (this.point.istrue)? "trending_up.png":"trending_down.png"
  var url =  `${window.location.origin}/${imageName}`;  
  let threshold = getThresholdValue(this.point.threshold_level).threshold  
  let stokeColor = getThresholdValue(this.point.threshold_level).OutlineColor
  let fillColor = getThresholdValue(this.point.threshold_level).color
  let aqi_data=this.point.aqi_data
  let pollen_data=this.point.pollen_data
  let aqiShow=(this.point.geo_type)==='ZIP3'?'flex':'none'
  // let color = '#007000'
  let aqi='AQI'
  let aqi_v=aqi_data!==null?aqi_data.split(':')[1]:'NA'
  let pollen=pollen_data!==null?pollen_data.split(':')[0]:''
  let pollen_v=pollen_data!==null?pollen_data.split(':')[1]:''
  // if (this.point.istrue) color = '#C40000'
  if (this.point.threshold_level<=0)
  {
    const divData =
    //return
    `<div style="
    padding-top:16px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 16px;
    height: 85px;
    background-color:white;
    font-family:Optum Sans;
    border: 1px solid #CBCCCD;
    border-radius: 4px;
    ">
    <div style="width:90%; padding-top:16px;padding-right:5px;display:inline;
    color: #002677;font-family:'Optum Sans';font-style: normal;font-weight: 700;
    font-size: 14px;line-height: 18px;
    ">${this.point.geo_name} </div>
    <br/>
    <span style="font-style: normal; padding-top:8px;font-weight: 700;
    font-size:14px; line-height: 18px; display: flex; align-items: center;
    color: #4B4D4F;">Actuals for Epiweek ${
      this.point.epiweek
    }: ${moment(this.point.week_ending).format('MMM DD, YYYY')}</span>
    <div style="padding-top:8px;">
    <div style="border-radius:0%;background-color:${fillColor}; 
    display: inline-block; width:16px; height:16px;border:1.5px solid ${stokeColor}"></div>&nbsp;
    <div style='display: inline-block; font-size:14px;font-weight:400;vertical-align:super;'>${threshold}</div>
    </div>`
  return divData
  }

else{


  const divData =
    //return
    `<div style="padding:16px;background-color:white;font-family:Optum Sans;border: 1px solid #CBCCCD;
    border-radius: 4px;">
    <div style="width:90%; padding-top:16px;padding-right:5px;display:inline;
    color: #002677;font-family:'Optum Sans';font-style: normal;font-weight: 700;
    font-size: 14px;line-height: 18px;
    ">${this.point.geo_name} </div>
    <br/>
    <span style="font-style: normal; padding-top:8px;font-weight: 700;
    font-size:14px; line-height: 18px; display: flex; align-items: center;
    color: #4B4D4F;">Week Ending: ${moment(this.point.week_ending).format('MMM DD, YYYY')}</span>
    <div style="padding-top:8px;display:flex">
    <div style="border-radius:0%;background-color:${fillColor}; 
    width:16px; height:16px;border:1px solid ${stokeColor}"></div>&nbsp;
    <div style='font-size:14px;font-weight:400;vertical-align:super;'>${threshold}</div>
    <div style='font-size:14px;font-weight:700;vertical-align:super;padding-left:10px'>${this.point.data_value}</div>
    <div style=' font-size:14px;font-weight:400;vertical-align:super;padding-left:10px;'><img style='height:24px;width:24px;' src="${url}"/></div>
    <div style='font-size:14px;font-weight:400;vertical-align:super;padding-left:10px;'>${toFixed(Math.abs(this.point.change_actual_percentage),2)}%</div>
    </div>
    <div>
    <div style='display:${aqiShow};background-color:#ECFAFC;padding:8px;radius:4px;margin-top:10px;'>
    <div style="font-style: normal; font-weight: 400;
    font-size:14px; line-height: 18px; display: flex; align-items: center;
    color:#002677;">${aqi}&nbsp <span style="font-family: 'Optum Sans', sans-serif;
    font-style:normal;font-weight: 700;font-size: 14px;
    line-height:18px;display: flex;align-items:center;padding:2px;
    ">${aqi_v}</span></div>  
    <div style="font-style: normal; font-weight: 400;
    font-size:14px; line-height: 18px; display: flex; align-items: center;
    color:#002677;padding-left:10px">${pollen}&nbsp  <span style="font-family: 'Optum Sans', sans-serif;
    font-style:normal;font-weight: 700;font-size: 14px;
    line-height:18px;display: flex;align-items:center;padding:2px
    ">${pollen_v}</span></div>  
    </div>              
     </div>    
    </div>`
  return divData
}
}

export default toolTipFormatter
